import { ApiResponse } from "@api/client";

export const getFileNameFormResponseHeader = (data: ApiResponse<any>) => {
  const stringWithFileName = data.raw.headers.get("content-disposition");
  const splitedString = stringWithFileName?.split('"');
  const fileName = splitedString?.[1] ?? undefined;
  return fileName;
};
